import {
  GitHub,
  LinkedIn,
  HomeOutlined,
  PersonOutline,
  SettingsOutlined,
  VisibilityOutlined,
  MailOutlineOutlined,
} from "@material-ui/icons";

export const NavItems = [
  {
    path: "/",
    icon_name: HomeOutlined,
  },
  {
    path: "/About",
    icon_name: PersonOutline,
  },
  {
    path: "/Skills",
    icon_name: SettingsOutlined,
  },
  {
    path: "/Work",
    icon_name: VisibilityOutlined,
  },
  {
    path: "/Contact",
    icon_name: MailOutlineOutlined,
  },
];

export const SocialItems = [
  {
    class: "navbar__social__github",
    link: "https://github.com/Vaibhav-afk/",
    icon_name: GitHub,
    style: { color: "#fff" },
  },
  {
    class: "navbar__social__linkedIn",
    link: "https://www.linkedin.com/in/vaibhav-2a44b91a4",
    icon_name: LinkedIn,
    style: { color: "#fff" },
  },
];
